export default "__VITE_ASSET__DMwwAysP__"